// extracted by mini-css-extract-plugin
module.exports = {"xs":"321px","sm":"551px","md":"801px","lg":"1281px","xl":"1921px"};